import store from "../store";
export default async function getLocalisationPage(page) {
    await store.dispatch('localization/pageLocal', {page});
    let local_page_keys = await store.getters['localization/pageLocal'];
    return local_page_keys;
}